// eslint-disable-next-line valid-jsdoc
/**
 * 地点标签管理
 */
angular.module('mediaTagManagerModule').controller('placeMarkCtrl', [
    '$scope',
    '$controller',
    'messagePublishService',
    function($scope, $controller, messagePublishService) {
        initScope();
        initStatus();
        initData();

        /**
         * [initScope 初始化作用域，继承素材库主控制器]
         *
         * @return  {[type]}          [return description]
         */
        function initScope() {
            let vm = this || window;
            let parentCtr = $controller('mediaTagCtrl', { $scope: $scope });
            vm = angular.extend(vm, parentCtr);
        }

        /**
         * [initStatus 初始化地点标签状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.name = '地点标签';
            $scope.queryParams.type = 'place';
        }

        /**
         * [initData 初始化地点标签数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.requestData();
        }
    },
]);
